import ForgotPassword from "./ForgotPassword.page";

export default ForgotPassword;
